import React from 'react';
import { Box, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import { CONTACT, createWhatsAppUrl } from './siteConfig';

function FixedIcons() {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: { xs: 14, md: 20 },
        left: { xs: '50%', md: 20 },
        right: 'auto',
        transform: { xs: 'translateX(-50%)', md: 'none' },
        zIndex: 1000,
        display: 'flex',
        flexDirection: { xs: 'row', md: 'column' },
        gap: { xs: 1, md: 2 },
        '& .MuiIconButton-root': {
          width: { xs: 40, md: 48 },
          height: { xs: 40, md: 48 },
        },
      }}
    >
      {/* Phone Icon */}
      <IconButton
        href={`tel:${CONTACT.phone}`}
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          backgroundColor: '#5A9BD4',
          color: '#fff',
          '&:hover': { backgroundColor: '#4682B4' },
        }}
      >
        <PhoneIcon />
      </IconButton>

      {/* WhatsApp Icon */}
      <IconButton
        href={createWhatsAppUrl('Halo, saya ingin mengetahui informasi BYD di BSD Serpong.')}
        target='_blank'
        rel='noopener noreferrer'
        sx={{
          backgroundColor: '#25D366',
          color: '#fff',
          '&:hover': { backgroundColor: '#1EBE54' },
        }}
      >
        <WhatsAppIcon />
      </IconButton>

      {/* Email Icon */}
      <IconButton
        href={`mailto:${CONTACT.email}?subject=Info%20BYD&body=Halo%20saya%20ingin%20tanya%20tentang%20BYD`}
        sx={{
          backgroundColor: '#EA4335',
          color: '#fff',
          '&:hover': { backgroundColor: '#C62828' },
        }}
      >
        <EmailIcon />
      </IconButton>
    </Box>
  );
}

export default FixedIcons;
